import Subcategories from './industry-sub-types';
export const AGRICULTURE = {
  label: 'Agriculture, Forestry and Fishing',
  value: 'AGRICULTURE',
  highRisk: false,
  subcategories: []
};
export const MINING = {
  label: 'Mining, Oil or Gas',
  value: 'MINING',
  highRisk: null,
  subcategories: Subcategories.MINING
};
export const TRANSPORTATION = {
  label: 'Transportation',
  value: 'TRANSPORTATION',
  highRisk: true,
  subcategories: []
};
export const COMMUNICATIONS = {
  label: 'Communications',
  value: 'COMMUNICATIONS',
  highRisk: false,
  subcategories: []
};
export const WHOLESALE = {
  label: 'Wholesale Trade ',
  value: 'WHOLESALE',
  highRisk: null,
  subcategories: Subcategories.WHOLESALE
};
export const RETAIL_RESTAURANT = {
  label: 'Retail Trade or Restaurant',
  value: 'RETAIL_RESTAURANT',
  highRisk: true,
  subcategories: []
};
export const FINANCE_INSURANCE = {
  label: 'Finance, Insurance and Real Estate',
  value: 'FINANCE_INSURANCE',
  highRisk: false,
  subcategories: []
};
export const SERVICES = {
  label: 'Services',
  value: 'SERVICES',
  highRisk: null,
  subcategories: Subcategories.SERVICES
};
export const PUBLIC_ADMINISTRATION = {
  label: 'Public Administration or Government',
  value: 'PUBLIC_ADMINISTRATION',
  highRisk: false,
  subcategories: []
};
export const OTHER = {
  label: 'Other',
  value: 'OTHER',
  highRisk: null,
  subcategories: Subcategories.OTHER
};
export const INDUSTRIES_MAP = {
  AGRICULTURE,
  MINING,
  TRANSPORTATION,
  COMMUNICATIONS,
  WHOLESALE,
  RETAIL_RESTAURANT,
  FINANCE_INSURANCE,
  SERVICES,
  PUBLIC_ADMINISTRATION,
  OTHER
};
export default Object.values(INDUSTRIES_MAP);
export const getSubcategories = industry => {
  const mappedIndustry = INDUSTRIES_MAP[industry];
  if (mappedIndustry) {
    return mappedIndustry.subcategories;
  }
  return [];
};